import { REQUEST_REGION, RECEIVE_REGION, FAILED_REGION } from "./../actions/weatherRegionActions";

export function weatherRegion(
  state = {
    isFetching: false,
    loadError: false,
    region: null,
    regionData: null,
    domain: false,
  },
  action
) {
  switch (action.type) {
    case REQUEST_REGION:
      return Object.assign({}, state, {
        loadError: false,
        isFetching: true,
      });
    case RECEIVE_REGION:
      return Object.assign({}, state, {
        isFetching: false,
        domain: false,
        region: action.region,
        regionData: action.regionData,
      });
    case FAILED_REGION:
      return Object.assign({}, state, {
        isFetching: false,
        loadError: true,
      });
    default:
      return state;
  }
}
